export { default } from './HideAnywhereApp';
